import React from 'react'

export const CheckDraftIconMobile = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <circle cx="8" cy="8" r="6" fill={color} />
    <circle
      cx="8.11621"
      cy="7.89233"
      r="5.75"
      fill="white"
      stroke={color}
      stroke-width="4"
    />
  </svg>
)
